import LogRocket from 'logrocket';
import 'url-search-params-polyfill';

export const appMixins = {
	getParameterFromUrl(name) {
		const url = new URLSearchParams(window.location.search);
		let result = url.get(name);

		// For the email parameters, we want to support + that are currently
		// considered encoded spaces by URLSearchParams
		if (result && name === 'email') {
			result = result.replace(' ', '+');
		}

		return result;
	},
};

export const translationMixin = {
	computed: {
		currentTranslation() {
			return this.$i18n.messages[this.$i18n.locale];
		},

		oppositeLocale() {
			return this.$i18n.locale === 'en' ? 'fr' : 'en';
		},

		titlesTranslation() {
			return this.currentTranslation.titles;
		},
	},
};

export const titleMixin = {
	mounted() {
		const title = this.$options.name.replace(/(?:^|\.?)([A-Z])/g, match => `-${match.toLowerCase()}`).substr(1);
		window.document.title = `${this.$i18n.messages[this.$i18n.locale].titles[title]} - Centiva`;
	},
};

export const marketingMixins = {
	initializeLogRocket() {
		if (process.env.VUE_APP_LOGROCKET_INIT) {
			LogRocket.init(process.env.VUE_APP_LOGROCKET_INIT);
		}
	},

	insertFacebookPixel() {
		if (process.env.VUE_APP_ENV === 'prod') {
			const script = document.createElement('script');
			script.innerHTML = "!function(f,b,e,v,n,t,s) {if(f.fbq)return;n=f.fbq=function(){n.callMethod? n.callMethod.apply(n,arguments):n.queue.push(arguments)}; if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0'; n.queue=[];t=b.createElement(e);t.async=!0; t.src=v;s=b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t,s)}(window, document,'script', 'https://connect.facebook.net/en_US/fbevents.js'); fbq('init', '1981137748841471'); fbq('track', 'PageView');";
			document.head.appendChild(script);
		}
	},

	insertGA4Tag() {
		if (process.env.VUE_APP_ENV === 'prod') {
			const script_tag = document.createElement('script');
			script_tag.async = true;
			script_tag.src = "https://www.googletagmanager.com/gtag/js?id=G-L4N409279R";
			document.head.appendChild(script_tag);

			const script_config = document.createElement('script');
			script_config.innerHTML = "window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-L4N409279R');";
			document.head.appendChild(script_config);
		}
	},
};
